export default "__VITE_ASSET__5df09ac2__"